module.exports = __webpack_public_path__ + "static/media/user_avatar.0a2708a8.png";